module.exports = __webpack_public_path__ + "img/logo.c153554b.png";